import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  eventContainer: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    boxShadow: "2px 4px 20px rgba(0, 0, 0, 0.1) !important",
    marginBottom: "20px",
    marginRight: "20px",
    borderRadius: "6px",
  },
  eventText: {
    height: "3rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    "Webkit-box-orient": "vertical",
    "-moz-box-orient": "vertical",
    "-webkit-line-clamp": "2",
    color: theme.palette.events.textPrimary,
  },
  eventImage: {
    height: "200px",
    backgroundSize: "cover",
    flexShrink: 0,
    img: {
      width: "100%",
      height: "200px",
      objectFit: "cover",
      transition: "all 0.2s ease-in-out",
    },
  },
  eventContent: {
    padding: "1.5rem",
    display: "grid",
    gridTemplateRows: "3rem 2.8rem 2rem",
    gridGap: "0.5rem",
  },
  footer: {
    borderTop: "1px solid #ededed",
    justifyContent: "space-between",
    padding: "10px 1.5rem",
    height: "60px",
    boxSizing: "border-box",
    flexShrink: 0,
    "& svg": {
      verticalAlign: "middle",
      fontSize: "1rem",
      borderRight: `2px solid ${theme.palette.events.textPrimary}`,
      paddingRight: "6px",
      marginRight: "6px",
    },
  },
  footerContent: {
    display: "flex",
    alignItems: "center",
  },
  personIcon: {
    width: "20px",
    height: "20px",
  },
}));
